import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import { BrowserRouter as Router} from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { dir } from "i18next";
import Layout from "./layout";
import { setupAxiosConfig } from "../Utils/api";
import { ToastContainer } from "react-toastify";
import RoutesComp from "./components/RoutesComp";

function App() {
  const currentLocale = i18n.language;
  // const navigate = useNavigate();

  // useEffect(() => {
  //   // Get user's selected language from localStorage, default to Arabic if none
  //   const userLanguage = getPersistedData("locale");
  //   i18n.changeLanguage(userLanguage || "ar");
  // }, []);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get("token");
  const Token = localStorage.getItem("Token")||"euibchyefbb";
  setupAxiosConfig(token);
  console.log(Token);

  if (token) {
    localStorage.setItem("Token", token);
  }

  

  return (
    <I18nextProvider i18n={i18n}>
      <ToastContainer />
      <div dir={dir(currentLocale)} className="!font-rubik">
        <ConfigProvider
          theme={{
            token: {
              borderRadius: 12,
              colorPrimary: "#52B44A",
              fontFamily: "Rubik, sans-serif",
            },
            components: {
              Button: {
                fontSize: 16,
                fontWeight: 700,
                lineHeight: "18.96px",
                letterSpacing: "0.02em",
                textAlign: "left",
                textUnderlinePosition: "from-font",
                textDecorationSkipInk: "none",
              },
              Checkbox: {
                colorPrimary: "#004C51",
                "border-radius": "5.727px",
                controlHeight: 20, // Controls checkbox size
                controlInteractiveSize: 20, // More reliable size setting
              },
            },
          }}
        >
          <Router>
            <RoutesComp />
          </Router>
        </ConfigProvider>
      </div>
    </I18nextProvider>
  );
}

export default App;
